import type { OverrideApprover, Team } from '@lms/shared-types'
import { apiRequest } from './client'

export function listTeams(): Promise<Team[]> {
  return apiRequest<Team[]>('/api/v1/teams')
}

export function updateTeamCoverage(
  teamId: string,
  slotPct: number,
  /** Justification for the capacity change (out-of-system process). Recorded
   *  in the audit trail. Required by the coverage editor when the flag is on. */
  reason?: string,
): Promise<Team> {
  return apiRequest<Team>(`/api/v1/admin/teams/${teamId}`, {
    method: 'PATCH',
    body: reason ? { slotPct, reason } : { slotPct },
  })
}

export interface TeamThresholdPatch {
  floor?: number | null
  criticalRoles?: string[] | null
  overrideApprover?: OverrideApprover | null
  /** Justification for a floor change; recorded in the audit trail. */
  reason?: string
}

export function updateTeamThresholds(
  teamId: string,
  patch: TeamThresholdPatch,
): Promise<Team> {
  return apiRequest<Team>(`/api/v1/admin/teams/${teamId}`, {
    method: 'PATCH',
    body: patch,
  })
}
